import { render } from "./Child.vue?vue&type=template&id=696caed1"
import script from "./Child.vue?vue&type=script&lang=ts"
export * from "./Child.vue?vue&type=script&lang=ts"
script.render = render

export default script